export default __webpack_public_path__ + "static/media/reactypescript.aad36af3.webp";